<template>
  <div class="t-input" :class="[{ invalid: error, 'is-focused': isFocused }]">
    <label>
      <div v-if="label" class="t-input__label">{{ label }}</div>
      <input
        ref="input"
        v-model="model"
        v-bind="{ placeholder }"
        @focus="isFocused = true"
        @blur="isFocused = false"
      />
    </label>
    <div v-if="error && (errorMessage || $slots.error)" class="t-input__error-message">
      <slot name="error">{{ errorMessage }}</slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TInput',

  props: {
    value: [String, Number, null],
    label: [String, Number, null],
    placeholder: [String, Number, null],
    error: Boolean,
    errorMessage: [String, Number, null],
    formatter: { type: Function, default: null }
  },

  data() {
    return {
      isFocused: false
    }
  },

  computed: {
    model: {
      get() {
        return this.value
      },

      set(val) {
        if (this.formatter) {
          const formattedValue = this.formatter(val)
          this.$emit('input', formattedValue)

          // refer to https://github.com/bootstrap-vue/bootstrap-vue/blob/dev/src/mixins/form-text.js#L162-L173
          const elInput = this.$refs['input']
          if (elInput && elInput.value !== formattedValue) {
            elInput.value = formattedValue
          }
        } else {
          this.$emit('input', val)
        }
      }
    }
  }
}
</script>
